export default "__VITE_ASSET__BTBYGxgR__"